import Modal from "@/components/ui/Modal";
import { useTranslations } from "next-intl";
import styles from "./index.module.css";

type SizeGuide = {
  sizeguide:
    | {
        chart: {
          [measurement: string]: string;
          size: string;
        }[];
        keys: string[];
      }
    | undefined;
};

const SizeChartTable = ({ sizeguide }: SizeGuide) => {
  const t = useTranslations();
  if (!sizeguide)
    return (
      <div>
        <p>{t("sizechart.emptysizechart")}</p>
      </div>
    );

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.heading}>Size</th>
          {sizeguide?.keys?.map((key: string) => (
            <th key={key} className={styles.heading}>
              {key}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sizeguide.chart.map((row) => (
          <tr key={row.size} className={styles.row}>
            <td className={styles.size}>{row.size}</td>
            {sizeguide.keys.map((key: string) => (
              <td className={styles.td} key={key}>
                {row[key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export const SizeChartModal = ({ sizeguide }: SizeGuide) => {
  return (
    <Modal title="Size chart" modal={"sizechart"}>
      <div className={styles.sizechart}>
        <SizeChartTable sizeguide={sizeguide} />
      </div>
    </Modal>
  );
};
